<div class="min-h-screen w-full flex flex-col items-center justify-center bg-gray-50">
  <div class="bg-white rounded-2xl shadow-[0_5px_25px_rgba(0,0,0,0.15)] p-10 max-w-md w-full mx-4 text-center">

    <!-- Loading -->
    <ng-container *ngIf="status === 'loading'">
      <i class="pi pi-spin pi-spinner text-5xl text-[--primary-500] mb-6"></i>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">Confirming your email...</h2>
      <p class="text-gray-500 text-sm">Please wait a moment.</p>
    </ng-container>

    <!-- Success -->
    <ng-container *ngIf="status === 'success'">
      <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <i class="pi pi-check text-3xl text-green-600"></i>
      </div>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">Email Confirmed!</h2>
      <p class="text-gray-500 text-sm mb-3">Your account has been verified. You can now sign in.</p>
      <p class="text-gray-400 text-xs mb-8">
        You will be redirected to the login page in {{ countdown }} second{{ countdown !== 1 ? 's' : '' }}...
      </p>
      <button
        pButton
        type="button"
        (click)="goToLogin()"
        class="w-full h-11 font-bold text-base bg-[--primary-500] text-white border-none hover:bg-[--primary-600] active:scale-[0.98] transition-all rounded-lg shadow-lg shadow-blue-500/20"
      >
        <span>Back to Login Page</span>
        <i class="pi pi-arrow-right ml-2"></i>
      </button>
    </ng-container>

    <!-- Error -->
    <ng-container *ngIf="status === 'error'">
      <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <i class="pi pi-times text-3xl text-red-500"></i>
      </div>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">Confirmation Failed</h2>
      <p class="text-gray-500 text-sm mb-8">The link may have expired or is invalid. Please try registering again.</p>
      <button
        pButton
        type="button"
        (click)="goToLogin()"
        class="w-full h-11 font-bold text-base bg-[--primary-500] text-white border-none hover:bg-[--primary-600] active:scale-[0.98] transition-all rounded-lg shadow-lg shadow-blue-500/20"
      >
        <span>Back to Login Page</span>
        <i class="pi pi-arrow-right ml-2"></i>
      </button>
    </ng-container>

  </div>
</div>
